export default {"src":"/_next/static/media/gri5.a639a411.svg","height":43,"width":64,"blurWidth":0,"blurHeight":0};